module.exports = __webpack_public_path__ + "img/image-01.691928f7.webp";